export default __webpack_public_path__ + "static/background-01-80a976e2f175015d70ccf254cdff2594.svg";